import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'

import {
  createEnvironment,
  initializeAcornsWebGlobalNamespace,
} from '@acorns/web-utils'

import Application from './application'
import { APP_LOAD_START_INIT } from './components/TrackAppLoadTime/constants'
import { CONFIGURATION } from './config/env'
import InjectFontStyles from './config/fonts'
import InjectGlobalStyles from './config/styles'
import { initDatadogRum } from './utils/datadog/rum'

export const init = () => {
  window.sessionStorage.setItem(APP_LOAD_START_INIT, Date.now().toString())

  // This is for a hack implemented while systemizing the side navigation feature toggle in @acorns/web-components.
  // See https://github.com/Acornsgrow/web-core/pull/1016 for more details.
  window.sessionStorage.setItem('web__has_side_navigation_bar', 'true')

  initializeAcornsWebGlobalNamespace()

  const environment = createEnvironment(CONFIGURATION)

  // Initialize google analytics
  ReactGA.initialize(environment.get('googleAnalytics'))
  ReactGA.set({
    build: environment.get('head'),
    release: environment.get('release'),
  })

  initDatadogRum({
    applicationId: process.env.DD_RUM_APPLICATION_ID ?? '',
    clientToken: process.env.DD_RUM_CLIENT_TOKEN ?? '',
    version: environment.get('release'),
    env: environment.get('buildEnv'),
  })

  ReactDOM.render(
    <>
      <InjectFontStyles />
      <InjectGlobalStyles />
      <Application environment={environment} />
    </>,
    document.getElementById('app'),
  )
}
